import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs/Observable';

import { ConstantsService } from 'app/services/constants-service';
import { ObservableRequestService } from 'app/services/observable-request.service';

/**
 * Service to fetch and create person related calls.
 */
@Injectable()
export class CreatePersonService {
    constructor(
        private requestService: ObservableRequestService,
        private domSanitizer: DomSanitizer) { }

    addPerson(body: Object): Observable<any> {
        const addPersonUrl = ConstantsService.ADD_PERSON_URL;
        return this.requestService.postRequest(addPersonUrl,
            this.requestService.serialize(body),
            this.requestService.getFormEncodedContentType());
    };
}

// @todo refactor


// WEBPACK FOOTER //
// ./src/app/shared/components/createperson/create-person.service.ts